"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7786],{

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ applyFnToProps; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Applies a function to properties of a specified type in an object, recursively.
 *
 * @param {Object} obj - The object to apply the function to.
 * @param {Function} fn - The function to apply to matching properties.
 * @param {string} [type='string'] - The type of properties to apply the function to.
 * @param {Array<string>} [ignoreKeys=[]] - The keys of properties to ignore and not modify.
 * @returns {Object} - The object with function recursively applied.
 */
function applyFnToProps(obj, fn, type = 'string', ignoreKeys = []) {
  if (!obj || typeof obj !== 'object') return obj;
  Object.keys(obj).forEach(property => {
    if (typeof obj[property] === 'object') {
      applyFnToProps(obj[property], fn, type, ignoreKeys);
    } else {
      // eslint-disable-next-line valid-typeof
      if (typeof obj[property] === type && !ignoreKeys.includes(property)) obj[property] = fn(obj[property]);
    }
  });
  return obj;
}

/***/ }),

/***/ 755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ timeToFirstByte; }
/* harmony export */ });
/* harmony import */ var _constants_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9152);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2148);
/* harmony import */ var _vital_metric__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2656);
/* harmony import */ var web_vitals_attribution__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8629);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */




const timeToFirstByte = new _vital_metric__WEBPACK_IMPORTED_MODULE_3__/* .VitalMetric */ .U(_constants__WEBPACK_IMPORTED_MODULE_1__/* .VITAL_NAMES.TIME_TO_FIRST_BYTE */ .S.TIME_TO_FIRST_BYTE);

/**
 * onTTFB is not supported in the following scenarios:
 * - in a non-browser scope
 * - in browsers that do not support PerformanceNavigationTiming API
 * - in an iOS browser
 * - cross-origin iframes specifically in firefox and safari
 */
if (_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserScope */ .il && typeof PerformanceNavigationTiming !== 'undefined' && !_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .isiOS */ .Tt && window === window.parent) {
  (0,web_vitals_attribution__WEBPACK_IMPORTED_MODULE_2__/* .onTTFB */ .mr)(({
    value,
    attribution
  }) => {
    if (timeToFirstByte.isValid) return;
    timeToFirstByte.update({
      value,
      attrs: {
        navigationEntry: attribution.navigationEntry
      }
    });
  });
} else {
  if (!timeToFirstByte.isValid) {
    const entry = {};
    // convert real timestamps to relative timestamps to match web-vitals behavior
    for (let key in _constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .globalScope */ ._A?.performance?.timing || {}) entry[key] = Math.max(_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .globalScope */ ._A?.performance?.timing[key] - _constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .originTime */ .sK, 0);

    // ttfb is equiv to document's responseStart property in timing API --> https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming/responseStart
    timeToFirstByte.update({
      value: entry.responseStart,
      attrs: {
        navigationEntry: entry
      }
    });
  }
}

/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timing/nav-timing.js
var nav_timing = __webpack_require__(1131);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/stringify.js
var stringify = __webpack_require__(4155);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/config/info.js
var info = __webpack_require__(8312);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/page_view_event/constants.js
var constants = __webpack_require__(5494);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/features/features.js
var features = __webpack_require__(4663);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/window/nreum.js
var nreum = __webpack_require__(3131);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/page_view_event/aggregate/initialized-features.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



/**
 * Get an array of flags required by downstream (NR UI) based on the features initialized in this agent
 * (aka what is running on the page).
 * @param {String} agentId - the ID of the initialized agent on the page, mapping to the one under the global 'newrelic' object
 * @returns {String[]} Up to 5 short strings corresponding to ingest mapping of features.
 */
function getActivatedFeaturesFlags(agentId) {
  const flagArr = [];
  const newrelic = (0,nreum/* gosNREUM */.fP)();
  try {
    Object.keys(newrelic.initializedAgents[agentId].features).forEach(featName => {
      switch (featName) {
        case features/* FEATURE_NAMES.ajax */.DT.ajax:
          flagArr.push('xhr');
          break;
        case features/* FEATURE_NAMES.jserrors */.DT.jserrors:
          flagArr.push('err');
          break;
        case features/* FEATURE_NAMES.genericEvents */.DT.genericEvents:
          flagArr.push('ins');
          break;
        case features/* FEATURE_NAMES.sessionTrace */.DT.sessionTrace:
          flagArr.push('stn');
          break;
        case features/* FEATURE_NAMES.softNav */.DT.softNav:
        case features/* FEATURE_NAMES.spa */.DT.spa:
          flagArr.push('spa');
          break;
      }
    });
  } catch (e) {}
  return flagArr;
}

// Note: this module and the "af" param in src/features/page_view_event/aggregate/index.js can be removed in the future at such time
// that it's no longer being used. For the browser agent, this is an unused flag system.
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/feature-flags.js
var feature_flags = __webpack_require__(5097);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/console.js
var console = __webpack_require__(1639);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/first-contentful-paint.js
var first_contentful_paint = __webpack_require__(3892);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/first-paint.js
var first_paint = __webpack_require__(3600);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/vitals/time-to-first-byte.js
var time_to_first_byte = __webpack_require__(755);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timing/now.js
var now = __webpack_require__(1595);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/config/runtime.js
var config_runtime = __webpack_require__(3807);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timing/time-keeper.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



/**
 * Class used to adjust the timestamp of harvested data to New Relic server time. This
 * is done by tracking the performance timings of the RUM call and applying a calculation
 * to the harvested data event offset time.
 */
class TimeKeeper {
  /**
   * Pointer to the current agent session if it exists.
   * @type {import('../session/session-entity').SessionEntity}
   */
  #session;

  /**
   * Represents the browser origin time corrected to NR server time.
   * @type {number}
   */
  #correctedOriginTime;

  /**
   * Represents the difference in milliseconds between the calculated NR server time and
   * the local time.
   * @type {number}
   */
  #localTimeDiff;

  /**
   * Represents whether the timekeeper is in a state that it can accurately convert
   * timestamps.
   * @type {boolean}
   */
  #ready = false;
  constructor(agentIdentifier) {
    this.#session = (0,config_runtime/* getRuntime */.O)(agentIdentifier)?.session;
    this.processStoredDiff();
  }
  get ready() {
    return this.#ready;
  }
  get correctedOriginTime() {
    return this.#correctedOriginTime;
  }
  get localTimeDiff() {
    return this.#localTimeDiff;
  }

  /**
   * Process a rum request to calculate NR server time.
   * @param rumRequest {XMLHttpRequest} The xhr for the rum request
   * @param startTime {number} The start time of the RUM request
   * @param endTime {number} The end time of the RUM request
   * @param nrServerTime {number} the unix number value of the NR server time in MS, returned in the RUM request body
   */
  processRumRequest(rumRequest, startTime, endTime, nrServerTime) {
    this.processStoredDiff(); // Check session entity for stored time diff
    if (this.#ready) return; // Server time calculated from session entity

    if (!nrServerTime) throw new Error('nrServerTime not found');
    const medianRumOffset = (endTime - startTime) / 2;
    const serverOffset = startTime + medianRumOffset;

    // Corrected page origin time
    this.#correctedOriginTime = Math.floor(nrServerTime - serverOffset);
    this.#localTimeDiff = runtime/* originTime */.sK - this.#correctedOriginTime;
    if (isNaN(this.#correctedOriginTime)) {
      throw new Error('Failed to correct browser time to server time');
    }
    this.#session?.write({
      serverTimeDiff: this.#localTimeDiff
    });
    this.#ready = true;
  }

  /**
   * Converts a page origin relative time to an absolute timestamp
   * using the user's local clock.
   * @param relativeTime {number} The relative time of the event in milliseconds
   * @returns {number} Corrected unix/epoch timestamp
   */
  convertRelativeTimestamp(relativeTime) {
    return runtime/* originTime */.sK + relativeTime;
  }

  /**
   * Converts an absolute timestamp to a relative timestamp using the
   * user's local clock.
   * @param timestamp
   * @returns {number}
   */
  convertAbsoluteTimestamp(timestamp) {
    return timestamp - runtime/* originTime */.sK;
  }

  /**
   * Corrects an absolute timestamp to NR server time.
   * @param timestamp {number} The unix/epoch timestamp of the event with milliseconds
   * @return {number} Corrected unix/epoch timestamp
   */
  correctAbsoluteTimestamp(timestamp) {
    return timestamp - this.#localTimeDiff;
  }

  /**
   * Corrects relative timestamp to NR server time (epoch).
   * @param {DOMHighResTimeStamp} relativeTime
   * @returns {number}
   */
  correctRelativeTimestamp(relativeTime) {
    return this.correctAbsoluteTimestamp(this.convertRelativeTimestamp(relativeTime));
  }

  /** Process the session entity and use the info to set the main time calculations if present */
  processStoredDiff() {
    if (this.#ready) return; // Time diff has already been calculated

    const storedServerTimeDiff = this.#session?.read()?.serverTimeDiff;
    if (typeof storedServerTimeDiff === 'number' && !isNaN(storedServerTimeDiff)) {
      this.#localTimeDiff = storedServerTimeDiff;
      this.#correctedOriginTime = runtime/* originTime */.sK - this.#localTimeDiff;
      this.#ready = true;
    }
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/traverse.js
var traverse = __webpack_require__(3403);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/page_view_event/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */















class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = constants/* FEATURE_NAME */.t;
  constructor(agentRef) {
    super(agentRef, constants/* FEATURE_NAME */.t);
    this.timeToFirstByte = 0;
    this.firstByteToWindowLoad = 0; // our "frontend" duration
    this.firstByteToDomContent = 0; // our "dom processing" duration

    if (!(0,info/* isValid */.JY)(agentRef.agentIdentifier)) {
      this.ee.abort();
      return (0,console/* warn */.Z)(43);
    }
    agentRef.runtime.timeKeeper = new TimeKeeper(agentRef.agentIdentifier);
    if (runtime/* isBrowserScope */.il) {
      time_to_first_byte/* timeToFirstByte.subscribe */.P.subscribe(({
        value,
        attrs
      }) => {
        const navEntry = attrs.navigationEntry;
        this.timeToFirstByte = Math.max(value, this.timeToFirstByte);
        this.firstByteToWindowLoad = Math.max(Math.round(navEntry.loadEventEnd - this.timeToFirstByte), this.firstByteToWindowLoad); // our "frontend" duration
        this.firstByteToDomContent = Math.max(Math.round(navEntry.domContentLoadedEventEnd - this.timeToFirstByte), this.firstByteToDomContent); // our "dom processing" duration

        this.sendRum();
      });
    } else {
      // worker agent build does not get TTFB values, use default 0 values
      this.sendRum();
    }
  }
  sendRum() {
    const info = this.agentRef.info;
    const measures = {};
    if (info.queueTime) measures.qt = info.queueTime;
    if (info.applicationTime) measures.ap = info.applicationTime;

    // These 3 values should've been recorded after load and before this func runs. They are part of the minimum required for PageView events to be created.
    // Following PR #428, which demands that all agents send RUM call, these need to be sent even outside of the main window context where PerformanceTiming
    // or PerformanceNavigationTiming do not exists. Hence, they'll be filled in by 0s instead in, for example, worker threads that still init the PVE module.
    measures.be = this.timeToFirstByte;
    measures.fe = this.firstByteToWindowLoad;
    measures.dc = this.firstByteToDomContent;
    const queryParameters = {
      tt: info.ttGuid,
      us: info.user,
      ac: info.account,
      pr: info.product,
      af: getActivatedFeaturesFlags(this.agentIdentifier).join(','),
      ...measures,
      xx: info.extra,
      ua: info.userAttributes,
      at: info.atts
    };
    if (this.agentRef.runtime.session) queryParameters.fsh = Number(this.agentRef.runtime.session.isNew); // "first session harvest" aka RUM request or PageView event of a session

    let body;
    if (typeof info.jsAttributes === 'object' && Object.keys(info.jsAttributes).length > 0) {
      body = (0,traverse/* applyFnToProps */.R)({
        ja: info.jsAttributes
      }, this.obfuscator.obfuscateString.bind(this.obfuscator), 'string');
    }
    if (runtime/* globalScope.performance */._A.performance) {
      if (typeof PerformanceNavigationTiming !== 'undefined') {
        // Navigation Timing level 2 API that replaced PerformanceTiming & PerformanceNavigation
        const navTimingEntry = runtime/* globalScope */._A?.performance?.getEntriesByType('navigation')?.[0];
        const perf = {
          timing: (0,nav_timing/* addPT */.wu)(runtime/* originTime */.sK, navTimingEntry, {}),
          navigation: (0,nav_timing/* addPN */.uB)(navTimingEntry, {})
        };
        queryParameters.perf = (0,stringify/* stringify */.P)(perf);
      } else if (typeof PerformanceTiming !== 'undefined') {
        // Safari pre-15 did not support level 2 timing
        const perf = {
          timing: (0,nav_timing/* addPT */.wu)(runtime/* originTime */.sK, runtime/* globalScope.performance.timing */._A.performance.timing, {}, true),
          navigation: (0,nav_timing/* addPN */.uB)(runtime/* globalScope.performance.navigation */._A.performance.navigation, {})
        };
        queryParameters.perf = (0,stringify/* stringify */.P)(perf);
      }
    }
    queryParameters.fp = first_paint/* firstPaint.current.value */.U.current.value;
    queryParameters.fcp = first_contentful_paint/* firstContentfulPaint.current.value */.y.current.value;
    const timeKeeper = this.agentRef.runtime.timeKeeper;
    if (timeKeeper?.ready) {
      queryParameters.timestamp = Math.floor(timeKeeper.correctRelativeTimestamp((0,now/* now */.z)()));
    }
    this.rumStartTime = (0,now/* now */.z)();
    this.agentRef.runtime.harvester.triggerHarvestFor(this, {
      directSend: {
        targetApp: this.agentRef.mainAppKey,
        payload: {
          qs: queryParameters,
          body
        }
      },
      needResponse: true,
      sendEmptyBody: true
    });
  }
  postHarvestCleanup({
    status,
    responseText,
    xhr
  }) {
    const rumEndTime = (0,now/* now */.z)();
    if (status >= 400 || status === 0) {
      (0,console/* warn */.Z)(18, status);
      // Adding retry logic for the rum call will be a separate change; this.blocked will need to be changed since that prevents another triggerHarvestFor()
      this.ee.abort();
      return;
    }
    const {
      app,
      ...flags
    } = JSON.parse(responseText);
    try {
      this.agentRef.runtime.timeKeeper.processRumRequest(xhr, this.rumStartTime, rumEndTime, app.nrServerTime);
      if (!this.agentRef.runtime.timeKeeper.ready) throw new Error('TimeKeeper not ready');
    } catch (error) {
      this.ee.abort();
      (0,console/* warn */.Z)(17, error);
      return;
    }
    this.agentRef.runtime.appMetadata = app;
    (0,feature_flags/* activateFeatures */.N)(flags, this.agentIdentifier);
    this.drain();
    this.agentRef.runtime.harvester.startTimer();
  }
}

/***/ })

}]);